<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <filter id="smishing-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="6"
          flood-color="#a78bfa"
          flood-opacity="0.5"
        />
      </filter>
    </defs>

    <g transform="translate(0 -7)">
      <!-- Circular connection line stays behind the phone, QR card, and shield -->
      <circle
        cx="100"
        cy="80"
        r="38"
        fill="none"
        stroke="#ddd6fe"
        stroke-width="1.5"
        stroke-dasharray="3 3"
        class="rotate"
      />

      <g class="float">
        <!-- Smaller phone with SMS -->
        <rect
          x="55"
          y="45"
          width="32"
          height="55"
          rx="5"
          fill="#f5f3ff"
          stroke="#a78bfa"
          stroke-width="1.5"
        />
        <rect
          x="59"
          y="52"
          width="24"
          height="38"
          rx="2"
          fill="white"
          stroke="#e9d5ff"
          stroke-width="1"
        />

        <!-- SMS bubbles -->
        <rect x="62" y="56" width="14" height="8" rx="3" fill="#ede9fe" />
        <rect x="62" y="68" width="11" height="7" rx="3" fill="#ede9fe" />
        <rect
          x="68"
          y="78"
          width="13"
          height="7"
          rx="3"
          fill="#7c3aed"
          class="pulse"
        />

        <!-- Phone notch -->
        <rect x="65" y="48" width="12" height="2" rx="1" fill="#ddd6fe" />

        <!-- QR code on right -->
        <rect
          x="110"
          y="45"
          width="35"
          height="35"
          rx="4"
          fill="#f5f3ff"
          stroke="#a78bfa"
          stroke-width="1.5"
        />
        <rect x="116" y="51" width="8" height="8" rx="1" fill="#7c3aed" />
        <rect x="130" y="51" width="8" height="8" rx="1" fill="#7c3aed" />
        <rect x="116" y="65" width="8" height="8" rx="1" fill="#7c3aed" />
        <rect x="128" y="63" width="4" height="4" fill="#c4b5fd" />
        <rect x="134" y="69" width="4" height="4" fill="#c4b5fd" />

        <!-- Shield protection below -->
        <g filter="url(#smishing-glow)">
          <circle
            cx="100"
            cy="115"
            r="12"
            fill="#f5f3ff"
            stroke="#c4b5fd"
            stroke-width="1"
          />
          <circle cx="100" cy="115" r="7" fill="#7c3aed" class="pulse" />
          <path
            d="M100 111 L103 112.5 L103 115.5 C103 117 100 118.5 100 118.5 C100 118.5 97 117 97 115.5 L97 112.5 Z"
            fill="white"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style scoped>
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.rotate {
  animation: rotate 50s linear infinite;
  transform-origin: 100px 80px;
}
.float {
  animation: float 4s ease-in-out infinite;
}
.pulse {
  animation: pulse 2.5s ease-in-out infinite;
}
</style>
